// extracted by mini-css-extract-plugin
var _1 = "TimelockStakeFormStyle-module__amount___zmOA2";
var _2 = "TimelockStakeFormStyle-module__button___Ppk1w";
var _3 = "TimelockStakeFormStyle-module__buyEthBtn___lIBs4";
var _4 = "TimelockStakeFormStyle-module__checkboxWraper___byGlP";
var _5 = "TimelockStakeFormStyle-module__header___K0xqW";
var _6 = "TimelockStakeFormStyle-module__headerWrapper___j4rBV";
var _7 = "TimelockStakeFormStyle-module__headerWrapperSection___ow4hb";
var _8 = "TimelockStakeFormStyle-module__input___MjGmF";
var _9 = "TimelockStakeFormStyle-module__label___JLZHG";
var _a = "TimelockStakeFormStyle-module__mainLabel___rqqlh";
var _b = "TimelockStakeFormStyle-module__restaking___GL8zs";
var _c = "TimelockStakeFormStyle-module__summarySection___Zh8Zk";
var _d = "TimelockStakeFormStyle-module__summarySectionTitle___JJBH2";
var _e = "TimelockStakeFormStyle-module__summarySectionValue___h8YAn";
var _f = "TimelockStakeFormStyle-module__wrapper___BgwMg";
export { _1 as "amount", _2 as "button", _3 as "buyEthBtn", _4 as "checkboxWraper", _5 as "header", _6 as "headerWrapper", _7 as "headerWrapperSection", _8 as "input", _9 as "label", _a as "mainLabel", _b as "restaking", _c as "summarySection", _d as "summarySectionTitle", _e as "summarySectionValue", _f as "wrapper" }
